import { useQuery } from 'react-query';

import { PaginatedMatterDocsWithCasesResponseDto } from '../../../../backend/src/case/doc/dto/doc-with-cases.response.dto';
import { MatterDocsFilters } from '../../../../backend/src/types/types';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export interface MatterDocsWithCasesParams {
  page?: number;
  pageSize?: number;
  filters?: Pick<MatterDocsFilters, 'startDate' | 'endDate' | 'processed' | 'searchQuery'>;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}

export const useGetMatterDocsWithCases = (matterId: string, params: MatterDocsWithCasesParams) => {
  const { fetchConfigGET } = useGetFetchConfig();
  const { page = 1, pageSize = 50, filters = {}, sortBy, sortOrder } = params;

  return useQuery<PaginatedMatterDocsWithCasesResponseDto>(
    [QueryEntity.MatterDocsWithCases, { matterId, page, pageSize, filters, sortBy, sortOrder }],
    async () => {
      const searchParams = new URLSearchParams();
      searchParams.set('page', page.toString());
      searchParams.set('pageSize', pageSize.toString());

      if (filters.searchQuery !== undefined) {
        searchParams.set('searchQuery', filters.searchQuery);
      }
      if (filters.processed !== undefined) {
        searchParams.set('processed', filters.processed ? 'true' : 'false');
      }
      if (filters.startDate) {
        searchParams.set('startDate', filters.startDate);
      }
      if (filters.endDate) {
        searchParams.set('endDate', filters.endDate);
      }
      if (sortBy) {
        searchParams.set('sortBy', sortBy);
      }
      if (sortOrder) {
        searchParams.set('sortOrder', sortOrder);
      }

      return fetch(
        `${APIBaseChronos}/api/matters/${matterId}/docs-with-cases?${searchParams.toString()}`,
        fetchConfigGET,
      ).then((res) => {
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        return res.json();
      });
    },
    { refetchOnWindowFocus: false, enabled: !!matterId },
  );
};
